import 'ts-replace-all';

export class FilePaths {

  // This function expects 2 paths, being the second of an item that is contained inside the first
  // It then returns the part that is not common.
  // Example
  //
  // Shorter Path : root/folder
  // Longer Path :  root/folder/subFolder/item.txt
  //
  // Return value : /subFolder/item.txt
  public static getRemainingPath(shorterPath : string, longerPath : string) {

    let result = '';

    // Check the shorter path is contained in the longer path
    if (longerPath.startsWith(shorterPath) === false) {
      return result;
    }

    const shorterPathLen = shorterPath.length;
    result = longerPath.substring(shorterPathLen);

    return result;
  }

  public static ensureFileNameIsSafe(fileName : string) : string {

    const charactersToAvoid : Array<string> = [
      '#',
      '%',
      '&',
      '{',
      '}',
      '\\',
      '<',
      '>',
      '*',
      '?',
      '/',
      '$',
      '!',
      "'",
      '"',
      ':',
      '@',
      '+',
      '`',
      '|',
      '=',
    ];

    let result = fileName;

    charactersToAvoid.forEach((c) => {
      result = result.replaceAll(c, '');
    });

    result = result.replaceAll(' ', '_');

    return result;
  }

  public static splitFileFromPath(filePath : string) : string[] {

    const filePathAdjusted : string = filePath.replaceAll('\\', '/');
    const lastSlashPos = filePathAdjusted.lastIndexOf('/');

    const dirPath = filePathAdjusted.substring(0, lastSlashPos + 1);
    const fileName = filePathAdjusted.substring(lastSlashPos + 1);

    return [dirPath, fileName];
  }

  public static normalize(path : string) : string {
    return path.replaceAll('\\', '/');
  }

  public static join(path1 : string, path2 : string) {
    let path1Adjusted = FilePaths.normalize(path1);
    const path2Adjusted = FilePaths.normalize(path2);

    while (path1Adjusted.endsWith('/') && path2Adjusted.startsWith('/')) {
      path1Adjusted = path1Adjusted.slice(0, path1.length - 1);
    }

    if (
      path1Adjusted.length > 0
      && path1Adjusted.endsWith('/') === false
      && path2Adjusted.startsWith('/') === false) {
      path1Adjusted += '/';
    }

    return path1Adjusted + path2Adjusted;
  }

  public static splitLastSegmentFromPath(path: string) : string[] {

    const adjustedPath = FilePaths.clearLastSlash(path);

    // Since the last slash was removed, we can now call the one that works with files
    return FilePaths.splitFileFromPath(adjustedPath);
  }

  public static clearLastSlash(path : string) : string {
    let adjustedPath = this.normalize(path);

    while (adjustedPath.endsWith('/')) {
      adjustedPath = adjustedPath.slice(0, adjustedPath.length - 1);
    }
    return adjustedPath;
  }

  public static joinPathsArray(pathParts : string[]) : string {
    let path = '';
    pathParts.forEach((pathPart) => {
      path = FilePaths.join(path, pathPart);
    });

    return path;
  }

  // --------------------------------------------------------------------------------------------
  // To prevent overloading single directories and avoid filesystem performance issues,
  // files must be stored in a balanced, sharded directory structure with multiple numeric levels
  // The sharding structure only depends in the file name and assumes its is either an md5sum or
  // an GUID (or any similar string that can work as an hash)
  // ---------------------------------------------------------------------------------------------
  public static getShardedPath(
    sFileName: string,
    iNumberOfLevels = 4,
  ) : string {
    const digits: string[] = [];

    for (let iLevel = 0; iLevel < iNumberOfLevels; iLevel++) {
      const char = sFileName[iLevel] || '0'; // Default to '0' if filename is too short
      const iHexValue = parseInt(char, 16);
      // eslint-disable-next-line no-restricted-globals
      const sDigit = (!isNaN(iHexValue) ? iHexValue % 10 : 0).toString();
      digits.push(sDigit);
    }
    return digits.join('/');
  }

}
